var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"40px","margin":"30px auto 20px auto"}},[_c('rotate-square2')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }